import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { InvestingEdges } from "features/entities/EntityCreatePage/FormSidebar/InvestingEdges/InvestingEdges";
import ShareClasses from "features/entities/EntityCreatePage/FormSidebar/ShareClasses";
import { FunctionalTypeFormSelect } from "features/entities/FunctionalTypeFormSelect";
import { LegalTypeFormSelect } from "features/entities/LegalTypeFormSelect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockGroup,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import { FormFieldPrefix } from "shared/components/form/FormFieldPrefix";
import { FormDateInput } from "shared/components/input/date/DateInput";
import { FormJurisdictionSelect } from "shared/components/input/select/JurisdictionSelect";
import { FormTextInput } from "shared/components/input/text/TextInput";
import { useToast } from "shared/components/toast/useToast";

const FormSidebar: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation(["common", "entity"]);
  const { showToast } = useToast();
  const navigate = useNavigate();

  return (
    <Box px={4} pt={6} pb="200px" height="100%" overflow="auto">
      <Text mb={4} textStyle="h3">
        {t("entity:create.title")}
      </Text>
      <ContentBlockGroup defaultExpanded={[0, 1]}>
        <FormDateInput
          name="effective_date"
          title={t("allocation:edit.effectiveDateOfChange")}
        />
        <ContentBlock>
          <ContentBlockHeader>
            <ContentBlockTitle>Entity Details</ContentBlockTitle>
          </ContentBlockHeader>

          <ContentBlockBody px={4} pb={4}>
            <FormFieldPrefix prefix="entity_data">
              <FunctionalTypeFormSelect
                isInvestorEntity={false}
                isFundFamilyRelated={true}
              />
              <FormTextInput
                name="legal_name"
                title={t("entity:fullEntityName")}
                type="text"
              />
              <FormTextInput
                name="short_name"
                title={t("entity:shortNameOptional")}
                type="text"
              />
              <FormTextInput
                name="external_id"
                title={t("entity:externalId")}
                type="text"
              />
              <FormDateInput
                name="formation_date"
                title={t("entity:formationDate")}
              />
              <FormJurisdictionSelect countryFieldName="jurisdiction_country" />
              <LegalTypeFormSelect />
            </FormFieldPrefix>
          </ContentBlockBody>
        </ContentBlock>
        <InvestingEdges />
        <ShareClasses />
      </ContentBlockGroup>

      <Box display="flex" flexDirection="row" justifyContent="flex-end" mt={4}>
        <Flex columnGap={4}>
          <Button
            colorScheme="secondary"
            onClick={() => {
              showToast({
                message: t("common:cancel"),
                variant: "warning",
              });
              navigate(-1);
            }}
          >
            {t("common:cancel")}
          </Button>
          <Button type="submit" colorScheme="primary" isLoading={isLoading}>
            {t("entity:create.actions.create_new")}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default FormSidebar;
